<template>
    <div class="autocomplete-wrapper">
        <input
            autocomplete="off"
            v-validate="'required'"
            ref="autocomplete"
            :data-vv-as="strippedName"
            :id="id"
            type="text"
            :class="
                `form-control ${
                    dropdownVisible && autocompleteOptions.length
                        ? 'autocomplete-open'
                        : ''
                }`
            "
            :disabled="isDisabled"
            :name="name"
            :value="item"
            :maxlength="maxlength"
            @focus="showDropdown"
            @blur="hideDropdown"
            @input="updateValue"
        />
        <transition name="shimmy">
            <ul
                ref="dropdown"
                class="autocomplete-dropdown"
                v-show="dropdownVisible && autocompleteOptions.length"
            >
                <li
                    v-for="opt in autocompleteOptions"
                    @click="emulatePlaceChange($event, opt)"
                    :key="opt.id"
                >
                    {{ opt.description }}
                </li>
            </ul>
        </transition>
        <InlineError
            :errors="errors"
            :type="name"
        />
    </div>
</template>

<script>
import { mapState } from "vuex";
import InlineError from "@C/Forms/InlineError";
export default {
    inject: ["$validator"],
    name: "AutoCompleteInput",
    data() {
        return {
            serviceLoaded: false,
            dropdownVisible: false
        };
    },
    props: {
        module: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        model: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        autocompleteOptions: {
            type: Array,
            default: () => []
        },
        changeHandler: {
            type: Function,
            default: e => e
        },
        emulatePlaceChange: {
            type: Function,
            required: true
        },
        disabledCheck: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: Number,
            default: null
        }
    },
    methods: {
        showDropdown() {
            this.dropdownVisible = true;
        },
        hideDropdown() {
            this.dropdownVisible = false;
        },
        updateValue(e) {
            const val = e.target.value;

            if (this.model.split(".").length < 2) {
                this.$store.commit(`${this.module}/${this.model}`, val);
            } else {
                let spl = this.model.split(".");
                let target = spl[spl.length - 1];
                this.$store.commit(`${this.module}/${target}`, val);
            }

            this.changeHandler(e);
        }
    },
    computed: {
        ...mapState(["formSubmitting"]),
        strippedName() {
            return this.name.split("_")[1];
        },
        item() {
            return _.get(this.$store.state[this.module], this.model);
        },
        isDisabled() {
            return this.disabledCheck || this.$store.state.formSubmitting;
        }
    },
    components: {
        InlineError
    }
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/AutoCompleteInput.vue